module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel3-f7a31787b12e51173947d69dab93bcf7.jpg";